import script from "./DesktopConfirmSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopConfirmSection.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopConfirmSection.vue?vue&type=style&index=0&id=b54640d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b54640d8"]])

export default __exports__